import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14.25 8a1.29 1.29 0 0 1-.78 1.07l-9.78 5.16a2 2 0 0 1-.87.26.91.91 0 0 1-.5-.13 1.74 1.74 0 0 1-.57-1.57v-2a1.12 1.12 0 0 1 1.12-1.32c.26 0 3.51-.79 6.47-1.47-3-.69-6.21-1.44-6.46-1.48a1.12 1.12 0 0 1-1.13-1.28v-2c0-.58.06-1.27.57-1.58a1.44 1.44 0 0 1 1.37.13l9.77 5.16A1.28 1.28 0 0 1 14.25 8Z';
const draw24px =
  'M22.32,12a1.75,1.75,0,0,1-1.17,1.42c-.47.21-15.32,7.17-16.85,7.9A3.31,3.31,0,0,1,3,21.68a1.39,1.39,0,0,1-.73-.2,2.45,2.45,0,0,1-.76-2.15V16.22c0-1.47.92-1.6,1.65-1.71C3.66,14.44,10.53,13,15.53,12c-5-1-11.87-2.44-12.38-2.52-.77-.11-1.65-.24-1.65-1.7V4.67a2.45,2.45,0,0,1,.76-2.15,2.15,2.15,0,0,1,2,.16l16.85,7.9A1.74,1.74,0,0,1,22.32,12Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const SendArrowFilledIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'sendArrowFilled')) as IconWithRender;

SendArrowFilledIcon.displayName = 'SendArrowFilledIcon';
SendArrowFilledIcon.propTypes = Icon.propTypes;
SendArrowFilledIcon.renderIcon = (props) => <SendArrowFilledIcon {...props} />;
export default SendArrowFilledIcon;
